module.exports = __webpack_public_path__ + "img/logo.766560a6.png";